export default __webpack_public_path__ + "static/media/Flag_of_Thailand.8c29e22e.svg";